// ---------------------------------------------------------------------------
// LLM-judge grader-type descriptor. Authored in-page via the system-prompt
// flow; supports the Evaluate tab; contributes the model + invocation Overview
// cards. (Server→view spec mapping lives in the domain-layer mapper next to the
// Grader model, so this UI descriptor stays free of that concern.)
// ---------------------------------------------------------------------------

import { Chat20Regular } from '@fluentui/react-icons';
import { lazy } from 'react';

import type { GraderTypeDescriptor } from '../graderType.types.js';

import { LlmOverviewSections } from './LlmOverviewSections.js';

// Lazy so importing the registry (done by the lightweight create-method dialog,
// grader list, and Overview tab) does not eagerly pull the create flow's
// heavier module graph — the create layout loads only when actually rendered.
const SystemPromptCreateLayout = lazy(() =>
  import('../../SystemPromptCreateLayout/SystemPromptCreateLayout.js').then(
    (m) => ({ default: m.SystemPromptCreateLayout }),
  ),
);

export const llmGraderDescriptor: GraderTypeDescriptor = {
  type: 'LlmGraderSpec',
  supportsEvaluate: true,
  OverviewSections: LlmOverviewSections,
  create: {
    method: 'systemPrompt',
    menuTitle: 'System prompt',
    menuDescription: 'Write the system prompt yourself.',
    menuIcon: <Chat20Regular />,
    renderLayout: () => <SystemPromptCreateLayout />,
  },
};
